export const canViewOnlineUsers = (user) =>
  typeof user?.email === 'string' && /^[^\s@]+@turenscape\.com$/i.test(user.email.trim());
